@if (sideNavService.selectedMainLink(); as selectedMainItem) {
  <div
    class="side-nav flex-row-start"
    #sideNav
    [class.expanded]="sideNavStatus() === sideNavStatusEnum.expanded && !!selectedMainItem.items.length"
    [class.expanded-over]="sideNavStatus() === sideNavStatusEnum.mouseenter && !!selectedMainItem.items.length">
    <div class="side-nav__collapse-btn" #arrowEl [toggleSideNav]="sideNav" [(status)]="sideNavStatus">
      <sxw-svg-icon
        name="sidebar"
        width="20"
        height="20"
        [class.active]="sideNavStatus() === sideNavStatusEnum.collapse || sideNavStatus() === sideNavStatusEnum.mouseleave">
      </sxw-svg-icon>
    </div>

    <div class="icons-bar-content flex-col-between" icons-bar>
      <!-- --------------------------------------- TOP NAV --------------------------------------- -->
      <div class="top-nav">
        <div class="brand-header flex-col-center">
          <span class="brand-emoji">📦</span>
          <span class="brand-label">SCM</span>
        </div>
        <ul class="flex-col-center gap-10">
          @for (item of sideNavService.mainLinks(); track item.id; let idx = $index) {
            @if (item.isShown && item.direction === "TOP") {
              <a [routerLink]="item.routerLink ? item.routerLink : null">
                <li
                  [pTooltip]="item?.tooltip ?? '' | translate"
                  [selectedItem]="sideNav"
                  [selectedItemId]="item.id"
                  [currentSelectedItemId]="sideNavService.selectedMainLink()?.id ?? null"
                  [arrowEl]="arrowEl"
                  [(status)]="sideNavStatus"
                  (statusChange)="setSelectedItem($event)"
                  (click)="clickItem(item)"
                  [hasNestedItems]="!!item.items.length"
                  [class.active]="item.isActive"
                  [class.expanded-item]="item.expanded && !item.isActive"
                  [routerLinkActive]="item.routerLink ? 'active-link' : ''"
                  #arla="routerLinkActive"
                  [routerLinkActiveOptions]="{
                    exact: item.routerLinkExact ?? false,
                  }">
                  @if (item.icon) {
                    <sxw-svg-icon
                      [class]="'icons'"
                      width="15"
                      height="15"
                      [name]="item.icon"
                      [fillColor]="item.isActive ? 'white' : item.expanded && !item.isActive ? 'var(--p-primary-700)' : 'black'"
                      [strokeColor]="item.isActive ? 'white' : item.expanded && !item.isActive ? 'var(--p-primary-700)' : 'black'"></sxw-svg-icon>
                  }
                </li>
              </a>
            }
          }
        </ul>
      </div>

      <!-- --------------------------------------- BOTTOM NAV --------------------------------------- -->
      <div class="bottom-nav">
        <ul class="flex-col-center gap-10">
          @for (item of sideNavService.mainLinks(); track item.id) {
            <a [routerLink]="item.routerLink ? item.routerLink : null">
              @if (item.isShown && item.direction === "BTN") {
                <li
                  [pTooltip]="item?.tooltip ?? '' | translate"
                  tooltipStyleClass="sxw-tooltip"
                  [selectedItem]="sideNav"
                  [selectedItemId]="item.id"
                  [currentSelectedItemId]="sideNavService.selectedMainLink()?.id ?? null"
                  [arrowEl]="arrowEl"
                  [(status)]="sideNavStatus"
                  (statusChange)="setSelectedItem($event)"
                  (click)="clickItem(item)"
                  [hasNestedItems]="!!item.items.length"
                  [class.active]="item.isActive || arla.isActive"
                  [class.expanded-item]="item.expanded && !item.isActive"
                  #arla="routerLinkActive"
                  [routerLinkActive]="item.routerLink ? 'active' : ''"
                  [routerLinkActiveOptions]="{
                    exact: item.routerLinkExact ?? false,
                  }">
                  @if (item.icon) {
                    <sxw-svg-icon
                      [class]="'icons'"
                      width="15"
                      height="15"
                      [name]="item.icon"
                      [fillColor]="item.isActive ? 'white' : item.expanded && !item.isActive ? 'var(--p-primary-700)' : 'black'"
                      [strokeColor]="item.isActive ? 'white' : item.expanded && !item.isActive ? 'var(--p-primary-700)' : 'black'"></sxw-svg-icon>
                  }
                </li>
              }
            </a>
          }
        </ul>
      </div>
    </div>

    @if (selectedMainItem.items.length) {
      <div #linkNav class="links-nav hide-mobile" links-nav>
        <div class="selected-item">
          <sxw-svg-icon [class]="'icons'" width="16" height="16" [name]="selectedMainItem.icon" fillColor="var(--p-primary-color)"></sxw-svg-icon>
          <span>{{ "SIDE_NAV." + selectedMainItem.label | translate }}</span>
        </div>
        <div class="items flex-col-center">
          <ul>
            @for (subItem of selectedMainItem.items; track subItem.id) {
              <ng-container [ngTemplateOutlet]="subItems" [ngTemplateOutletContext]="{ $implicit: subItem, depth: 0 }"></ng-container>
            }
          </ul>
        </div>
      </div>
    }
  </div>
}

<!-- Render SubMenuItems and nested SubMenuItems -->
<ng-template #subItems let-subItem let-depth="depth">
  <a [routerLink]="subItem.routerLink ? subItem.routerLink : null" class="nav-item-link">
    @if (subItem.isShown) {
      <li
        class="flex-row-start nav-item"
        (click)="clickItem(subItem)"
        [class.open]="subItem.expanded"
        [routerLinkActive]="subItem.routerLink ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: subItem.routerLinkExact ?? false }">
        @if (subItem.icon) {
          <sxw-svg-icon
            [class]="'icons'"
            width="16"
            height="16"
            [name]="subItem.icon"
            [fillColor]="subItem.isActive ? 'white' : 'black'"
            [strokeColor]="subItem.isActive ? 'white' : 'black'"></sxw-svg-icon>
        }
        <span>{{ "SIDE_NAV." + subItem.label | translate }}</span>
        @if (subItem?.items?.length) {
          <div class="expand-icon" [class.open]="subItem.expanded">
            <sxw-svg-icon name="down-arrow" width="10"></sxw-svg-icon>
          </div>
        }
      </li>
    }
  </a>

  @if (subItem.items.length) {
    <ul class="sub-menu sub-menu-{{ depth | json }}" [@expand-nav-item]="subItem.expanded ? 'expanded' : 'collapsed'" [class.open]="subItem.expanded">
      @for (item of subItem.items; track item.id) {
        <ng-container [ngTemplateOutlet]="subItems" [ngTemplateOutletContext]="{ $implicit: item, depth: depth + 1 }"></ng-container>
      }
    </ul>
  }
</ng-template>
